module.exports = __webpack_public_path__ + "img/randomizer-details4.b0f88ffc.png";